import React from 'react';
import { motion } from 'framer-motion';
import services from '../../Assets/serviceBg.jpg';
import './services.css';

const Services = () => {
  const servicesData = [
    'Lojman sakinlerinden alınan aidatlardan işçi maaşlarını ödemek',
    'Emekli olan işçilere kıdem tazminatı ödemek',
    'Çöp toplamak',
    'Binaları temizlemek',
    'Çevre temizliği yapmak',
    'İşçi mahkemelerini takip etmek ve Rektörlüğün istediği gerekli belgeleri hazırlamak',
    'Lağım temizliği yapmak',
    'Lağım basan bodrum katlarındaki evleri temizlemek',
    'Su tesisatı arızalarını tamir etmek',
    'Sulama sistemini düzenlemek ve arızaları gidermek',
    'Fayans, bordor taşı, beton tamirleri yapmak',
    'Dolap, kapı, masa gibi marangozluk işleri yapmak',
    'Çilingirlik hizmeti yapmak',
    'İlaçlama yapmak',
    'Lojmanları ilgilendiren her konuda sakinleri bilgilendirmek (elektrik, su kesintisi gibi)',
    'Kış aylarında lojman sakinlerinin kalorifer şikayetlerini ısı santraline bildirmek',
    'Komşular arasındaki anlaşmazlıkları çözmek',
    'Huzuru bozucu ve genel ahlak kurallarına uymayan lojman sakinleri hakkında soruşturma açmak ve uyarmak',
    'Lojmanların güvenliğini kontrol etmek',
    'Çocuk parklarındaki arızalı oyun aletlerini tamir etmek',
    'Lojmanlardaki her türlü tamir için ihale yöntemiyle malzeme satın almak',
    'Yeşil alanların sulamasını yapmak',
    'Lojmanlardan toplanan katı atıkları dönüşüm için ayrıştırmak',
  ];

  return (
    <div className="services-page">
      <div className="services-page-bg">
        <img src={services} alt="" />
      </div>
      <div className="services-container">
        <h2 className="services-title">Lojman Hizmetlerimiz</h2>
        <div className="services-list">
          {servicesData.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: index * 0.006 }}
              viewport={{ amount: 0.7, once: true }}
            >
              <p>{service}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
